import { useSelector } from 'react-redux'
import type { UsersAccessListState } from './types'
import type { State } from '../types'

export const useAllAccess = (): Partial<UsersAccessListState> => {
  const { accessList = [], isLoading, isInitalized } = useSelector((state: State) => state.accessList)
  return { accessList, isLoading, isInitalized }
}
